import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { LookInside } from './components/LookInside';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { leaderVoices, moreLeaderVoices } from './data/testimonials';
export function App() {
  return <div className="min-h-screen w-full bg-paper font-sans text-pine selection:bg-ember selection:text-pine" data-id="element-0" data-mp="3ij65gd4jrr9g">
      <MetaPixel data-id="element-1" data-mp="3mjzpgvevclx2" />
      <main data-id="element-2" data-mp="3mjgclt42snpw">
        <Hero data-id="element-3" data-mp="3rc9d24sih9w6" />
        <SocialProofBar data-id="element-4" data-mp="3rbr9so7flver" />
        <PainGrid data-id="element-5" data-mp="3rdatkosaqola" />
        <ProductReveal data-id="element-6" data-mp="3rcsuzli5vya7" />
        <LookInside data-id="element-7" data-mp="3relv0hy9rk98" />
        <Tomes data-id="element-8" data-mp="5opiv1o0k3w" />
        <Bonuses data-id="element-9" data-mp="6801qozk67w" />
        <ValueStack data-id="element-10" data-mp="4n6o4eeqtbm" />
        <Urgency data-id="element-11" data-mp="56qxrrj5tst" />
        <Pricing data-id="element-12" data-mp="7sxpp6lk59z" />
        <Testimonials voices={leaderVoices} background="white" data-id="element-13" data-mp="2zld43f9knpe6" />
        <Guarantee data-id="element-14" data-mp="2zn6bwxvx8fnr" />
        <Faq data-id="element-15" data-mp="33mowfsjtyoq2" />
        <Testimonials voices={moreLeaderVoices} title="Every leader hits the same wall" background="panel" data-id="element-16" data-mp="33m5a7zn5de68" />
        <CostOfInaction data-id="element-17" data-mp="38kgkucl9nspi" />
        <Close data-id="element-18" data-mp="38o4d78ez692n" />
      </main>
      <Footer data-id="element-19" data-mp="3dle4yupu6wtn" />
      <PurchaseNotifications data-id="element-20" data-mp="3dlw542fmdv6u" />
    </div>;
}